export const tenantQueryKeys = {
  base: ['tenant'] as const,
  garageTenants: () => [...tenantQueryKeys.base, 'garageTenants'] as const,
  companyEmails: (tenantCompanyId: number) => [...tenantQueryKeys.base, 'emails', tenantCompanyId] as const,
  roles: () => [...tenantQueryKeys.base, 'roles'] as const,
  types: () => [...tenantQueryKeys.base, 'types'] as const,
  count: () => [...tenantQueryKeys.base, 'count'] as const,
};
